import * as React from 'react';

import { translate } from '~l10n/client';

import { PaywallTouchEventAdapter } from '~analytics/adapters/PaywallTouchEventAdapter';
import { ViewPricingTableEventAdapter } from '~analytics/adapters/ViewPricingTableEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { AlertMessage } from '~shared/components/AlertMessage';
import { Link } from '~shared/components/Link';
import { proCheck } from '~teacher/util/proCheck';

export function DeletedQuizUpgradeBanner() {
  if (proCheck.canRestoreTrash()) {
    return <div className="pt-6" />;
  }

  return (
    <>
      <AlertMessage tone="promote">
        <div className="flex flex-wrap -ml-2">
          <div className="ml-2">
            {translate(
              'Deleted quizzes can be restored when you upgrade to Socrative Pro.'
            )}{' '}
            <Link
              href={'#pricing'}
              onClick={() => {
                new PaywallTouchEventAdapter(
                  PaywallScreens.QuizListBannerDeleted
                ).sendAnalytics();
                new ViewPricingTableEventAdapter({
                  source: 'paywall',
                  paywall_feature: PaywallScreens.QuizListBannerDeleted,
                }).sendAnalytics();
              }}
            >
              {translate('Upgrade now')}
            </Link>
          </div>
        </div>
      </AlertMessage>
      <div className="pt-3" />
    </>
  );
}
